import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

import { format } from 'app/shared/utils/string.util';
import { IDataflowTypeMetadataSource } from 'app/extensibility/metadatas/resource-type/dataflow-format-type-metadata';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';

const dataflowSmartsheetSource: IDataflowTypeMetadataSource = {
    type: DatasetFormatType.Smartsheet,
    displayName: stringResources.Smartsheet_DisplayText,
    settings: adfModelTypeMap.smartsheet.dataflowSettings,
    controls: [
        {
            type: 'dataflow-smartsheet-entity-selection',
            bind: {
                schemaName: 'schemaName',
                tableName: 'tableName'
            }
        }
    ],
    useInlineProjection: true
};

export const smartsheetMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.smartsheet.linkedServiceType,
    displayName: format(stringResources.ModelName_DisplayTextPreviewTemplate, stringResources.Smartsheet_DisplayText),
    linkedServiceKind: 'unknown',
    icon: {
        className: 'svg-i-100x100-smartsheet'
    },
    category: ['ServicesApps'],
    onlyAzureIR: true,
    copySourceTypes: [],
    copySinkTypes: [],
    isFirstClass: true,
    supportDataFlowSource: true,
    dataflowSource: [dataflowSmartsheetSource],
    supportFirstClassParameterExperience: true,
    controls: [
        {
            type: 'dynamic-akv-switcher',
            enableAKVParameterization: true,
            hideAKVSwitcherInConnStrProps: true,
            bind: 'apiToken',
            label: stringResources.ModelName_Token,
            child: {
                type: 'parameterizable',
                attribute: 'apiToken',
                disableAddParameter: true,
                child: {
                    type: 'password',
                    label: stringResources.ModelName_Token,
                    required: true,
                    isLabelVertical: true,
                    validators: [
                        { type: 'required', errorMessage: '' }
                    ]
                }
            },
            description: format(
                stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Smartsheet_DisplayText),
                stringResources.ModelName_Token
            )
        }
    ]
};
